import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';

import { verticalSpace } from '@doltech/utils/lib/css-style';

const Container = styled.div`
  ${verticalSpace(16)}
`;

export const ShortAnswerQuestion = (props: RenderElementProps) => {
  const { children, attributes } = props;

  return (
    <Container className="short-answer-question" {...attributes}>
      {children}
    </Container>
  );
};
